import { format } from 'date-fns'
import Vue from 'vue'

function fmtDate (date, dateFormat = 'D MMM YYYY') {
  return date ? format(date, dateFormat) : ''
}

function fmtDateInterval (start, end, usePlaceholders = false) {
  let _start
  let _end

  if (start) {
    _start = new Date(start)
  } else {
    return usePlaceholders ? 'Start Date / End Date' : ''
  }

  if (end) {
    _end = new Date(end)
  } else {
    const s = fmtDate(_start)
    return usePlaceholders ? `${s} / End Date` : s
  }

  let ret = fmtDate(_end)

  if (!_end || start === end) {
    return ret
  } else {
    ret = `/ ${ret}`
  }

  if (_start.getFullYear() !== _end.getFullYear()) {
    ret = `${_start.year} ${ret}`
  }

  if (_start.getMonth() !== _end.getMonth()) {
    ret = format(_start, 'MMM') + ' ' + ret
  }

  ret = `${_start.getDate()} ${ret}`

  return ret
}

Vue.filter('fmtDate', fmtDate)
Vue.filter('fmtDateInterval', fmtDateInterval)

export {
  fmtDate,
  fmtDateInterval
}
